import dinerPath from '@/utils/env'

const hostname = window && window.location && window.location.hostname;
const nowUrl = window.location.href;
const protoo=window.location.protocol;
if(nowUrl.indexOf("order")!=-1){
    //url包含order域名
}else{
    if(hostname=== 'localhost'||hostname=== '106.14.192.98'||hostname=== '192.168.0.103'||hostname=== '47.100.41.121'||protoo=="file:"){
        //本地测试，测试服务器不需要跳转
    }else{
        // console.log("老的URL")
        window.location.href = 'https://order.lunchbox.asia/' + dinerPath + '/#' + nowUrl.split("#")[1];
    }
}